import React from "react";
import AuditionCardReuse from "../../../../AuditionAdmin/AuditionCardReuse";
import LiveAuditionSliderStar from "../LiveAuditionSliderStar/LiveAuditionSliderStar";
import SuperstarAuditionNav from "../SuperstarAuditionNav/SuperstarAuditionNav";

const SuperstarAuditionLive = () => {
  return (
    <div className="">
      <SuperstarAuditionNav />

      <div className=" mt-3">
        <LiveAuditionSliderStar />
      </div>
    </div>
  );
};

export default SuperstarAuditionLive;
